"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _LowRatesTV = _interopRequireDefault(require("./themes/LowRatesTV"));
var _LowRatesInBoundNoNPC = _interopRequireDefault(require("./themes/LowRatesInBoundNoNPC"));
var _NET = _interopRequireDefault(require("./themes/NET007"));
var _CreditKarma = _interopRequireDefault(require("./themes/CreditKarma"));
var _AutismHeroes = _interopRequireDefault(require("./themes/AutismHeroes"));
var _CapitalHomeMortgage = _interopRequireDefault(require("./themes/CapitalHomeMortgage"));
var _FLWNET = _interopRequireDefault(require("./themes/FLWNET049"));
var _SWMC = _interopRequireDefault(require("./themes/SWMC"));
var _requestRates_DEFAULT = _interopRequireDefault(require("./themes/includes/requestRates_DEFAULT.json"));
var _INHNPORT = _interopRequireDefault(require("./themes/INHNPORT017"));
var _NET2 = _interopRequireDefault(require("./themes/NET021"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* 06/25/2020 - Christian Maldonado

    Purpose:
	This class will determine which theme styling and request parameters to use depending on the theme.

    Backgroud:
    Pages that include this general rate-quote module need to pass the lead source of the page as we will
    use it to determine which files we will use to customize the component for that page in particular.
    Example: https://swmc-landingpages.s3.amazonaws.com/rate-quotes?leadSource=TEXAS-TV

    Requirements for a theme (this is subject to change based on the best implementation that satisfies our needs):
    1. Lead source -> Each theme will be determined by the lead source (this can be changed to some other parameter). The parameter will be
                      added in the switch case inside function loadThemeParams().
    2. A class/module that extends Component -> Each theme should have a class/module that can make the necessary imports and return the
                       parameters needed in the page. See src/modules/themes/LowRates.js as an example.
    3. Request Rates JSON files (optional) -> json files that deterine parameters that the pricing engine needs.
                       See src/modules/themes/includes/requestRatesNoCC_LOWRATES.json for an example.
    4. CSS file (optional) -> A styling sheet (css) that can override the colors and properties of elements in the page.
                       See /src/modules/themes/css/lowratestv.css for an example.

    Current limitations:
        - Right now when the page loads it does the imports of LowRates and LowRatesTV and automatically does the imports for the
          css files of each one. You can see it in the inspect element of the top banner of the page. You'll see that for #topBanner
          there are 2 or 3 entries. We need to find a solution so that it only loads the default css and the css of the theme that
          will be applied.

    Work to do:
        - Need to allow customization of important components in the page like the buttons that we show for each loan program (FHA, VA, etc.)
          Example: LowRates.tv only shows Conventional, FHA and VA but LowRates.com shows those plus USDA. Therefore, the sections should be
          customizable for that too.
        - Ask Dennis for more details on what more needs to be customizable.
*/

class ThemeConfig extends _react.Component {
  constructor(props) {
    super(props);
    this.loadThemeParams(props.leadSource);
  }
  loadThemeParams(leadSource) {
    switch (leadSource) {
      case "TEXAS-TV":
        const lrtv = new _LowRatesTV.default();
        this.requestRates = lrtv.getRequestRates();
        this.isNoCCProgram = lrtv.isNoCCProgram;
        this.isLowPaymentProgram = lrtv.isLowPaymentProgram;
        this.domain = "lowrates.tv";
        break;
      case "NET049":
        const flw = new _FLWNET.default();
        this.requestRates = flw.getRequestRates();
        this.isNoCCProgram = flw.isNoCCProgram;
        this.isLowPaymentProgram = flw.isLowPaymentProgram;
        this.domain = "frontlinewarriors.swmc.com";
        break;
      case "NET007":
        const lowr = new _NET.default();
        this.requestRates = lowr.getRequestRates();
        this.isNoCCProgram = lowr.isNoCCProgram;
        this.isLowPaymentProgram = lowr.isLowPaymentProgram;
        this.domain = "lowrates.com";
        break;
      case "NET021":
        const getva = new _NET2.default();
        this.requestRates = getva.getRequestRates();
        this.isNoCCProgram = getva.isNoCCProgram;
        this.isLowPaymentProgram = getva.isLowPaymentProgram;
        this.domain = "getvahomeloan.com";
        break;
      case "CREDKARMA":
        const ck = new _CreditKarma.default();
        this.requestRates = ck.getRequestRates();
        this.isNoCCProgram = ck.isNoCCProgram;
        this.isLowPaymentProgram = ck.isLowPaymentProgram;
        this.domain = "swmc.com";
        break;
      case "INBOUNDNONPC":
        const ah = new _AutismHeroes.default();
        this.requestRates = ah.getRequestRates();
        this.isNoCCProgram = ah.isNoCCProgram;
        this.isLowPaymentProgram = ah.isLowPaymentProgram;
        this.domain = "swmc.com";
        break;
      case "BL617RAN003":
        const chm = new _CapitalHomeMortgage.default();
        this.requestRates = chm.getRequestRates();
        this.isNoCCProgram = chm.isNoCCProgram;
        this.isLowPaymentProgram = chm.isLowPaymentProgram;
        this.domain = "capitalhomemortgage.com";
        break;
      case "NET001":
        const swmc = new _SWMC.default();
        this.requestRates = swmc.getRequestRates();
        this.isNoCCProgram = swmc.isNoCCProgram;
        this.isLowPaymentProgram = swmc.isLowPaymentProgram;
        this.domain = "swmc.com";
        break;
      case "INHNPORT-017":
        const cashout = new _INHNPORT.default();
        this.requestRates = cashout.getRequestRates();
        this.isNoCCProgram = cashout.isNoCCProgram;
        this.isLowPaymentProgram = cashout.isLowPaymentProgram;
        this.domain = "swmc.com";
        break;
      default:
        this.requestRates = _requestRates_DEFAULT.default;
        this.isNoCCProgram = false;
        this.isLowPaymentProgram = true;
        break;
    }
  }
}
var _default = exports.default = ThemeConfig;